import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {StemDate} from "../../stem-core/time/Date";

@makeEnum
export class PolicyType extends BaseEnum {
    static COOKIE;
    static TOS;
    static PRIVACY;
}

@globalStore
export class PolicyTerms extends BaseStore("PolicyTerms") {
    @field(Date) createdAt: StemDate;
    @field(PolicyType) type: PolicyType;
    @field(String) htmlTemplate: string;
}


export async function apiAdminCreatePolicy(request: any): Promise<any> {
    return apiClient.post("/compliance/create_policy/", request);
}
